<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">All Internal Account</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <AllInternalAccountTable></AllInternalAccountTable>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * Create Bank Component
 */


import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";

export default {
  page: {
    title: "All Internal Account",
    meta: [{ name: "All Internal Account", content: window.__env.app.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      createBankFormBody: {
        source: "web"
      },
      title: "All Internal Account",

      items: [
        {
          text: "Internal Account",
          href: "/"
        },
        {
          text: "Create Internal Account",
          active: true
        }
      ]
    };
  },
  methods: {}
};
</script>
